const TIMESTAMP = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/;

/**
 * "2026-08-28 13:55:19" to "28.08.2026 13:55", matching the legacy `date('d.m.Y H:i')`.
 *
 * Deliberately string-only: the API sends server-local DATETIME values with no zone,
 * and feeding those to `new Date()` would shift every timestamp for anyone whose
 * browser sits in a different zone than the VPS.
 */
export function formatTimestamp(value: string): string {
  const match = TIMESTAMP.exec(value);
  if (!match) return value;

  const [, year, month, day, hour, minute] = match;
  return `${day}.${month}.${year} ${hour}:${minute}`;
}

/** `2026-08-28` or a DATETIME prefix to `28.08.2026`. */
export function formatDate(value: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!match) return value;
  const [, year, month, day] = match;
  return `${day}.${month}.${year}`;
}

/** Percentage with one decimal and no trailing ".0", as the legacy sidebar rendered it. */
export function formatPercent(part: number, total: number): string {
  if (total <= 0) return "0";
  return (Math.round((part / total) * 1000) / 10).toString();
}

/** Polish plural for "głos": 1 głos, 2-4 głosy, 5+ głosów. */
export function pluralVotes(count: number): string {
  const lastTwo = count % 100;
  const last = count % 10;

  if (count === 1) return "1 głos";
  if (last >= 2 && last <= 4 && (lastTwo < 12 || lastTwo > 14)) {
    return `${count} głosy`;
  }
  return `${count} głosów`;
}
